import type { ReferencePatent } from '../types';

export interface PatentProfileRepository {
    getPatentProfileRepository(patentNo: string): Promise<ReferencePatent>;
}

export const PatentProfileRepository = Symbol('PatentProfileRepository');
